.day-name {
  font-size: 1.6rem;
  font-weight: 400;
  color: var(--color-grayscale-white, #fafafa);
  line-height: 2.4rem;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem;
  border-radius: 0.4rem;
  background-color: var(--color-primary-sandal);
}

.date-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.8rem;
  color: var(--color-grayscale-ghost);
}

.time-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
